export default {"src":"/_next/static/media/ra-arrow-up.1df514c9.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};